export const TEMPLATES_LOAD = 'TEMPLATES_LOAD';
export const TEMPLATES_LOAD_SUCCESS = 'TEMPLATES_LOAD_SUCCESS';
export const TEMPLATES_LOAD_ERROR = 'TEMPLATES_LOAD_ERROR';
export const TEMPLATES_ADD = 'TEMPLATES_ADD';
export const TEMPLATES_ADD_SUCCESS = 'TEMPLATES_ADD_SUCCESS';
export const TEMPLATES_ADD_ERROR = 'TEMPLATES_ADD_ERROR';
export const TEMPLATE_ADD = 'TEMPLATE_ADD';
export const TEMPLATE_ADD_SUCCESS = 'TEMPLATE_ADD_SUCCESS';
export const TEMPLATE_ADD_ERROR = 'TEMPLATE_ADD_ERROR';
export const TEMPLATES_UPDATE = 'TEMPLATES_UPDATE';
export const TEMPLATES_UPDATE_SUCCESS = 'TEMPLATES_UPDATE_SUCCESS';
export const TEMPLATES_UPDATE_ERROR = 'TEMPLATES_UPDATE_ERROR';
export const TEMPLATE_UPDATE = 'TEMPLATE_UPDATE';
export const TEMPLATE_UPDATE_SUCCESS = 'TEMPLATE_UPDATE_SUCCESS';
export const TEMPLATE_UPDATE_ERROR = 'TEMPLATE_UPDATE_ERROR';
export const TEMPLATES_DELETE = 'TEMPLATES_DELETE';
export const TEMPLATES_DELETE_SUCCESS = 'TEMPLATES_DELETE_SUCCESS';
export const TEMPLATES_DELETE_ERROR = 'TEMPLATES_DELETE_ERROR';
export const TEMPLATE_DELETE = 'TEMPLATE_DELETE';
export const TEMPLATE_DELETE_SUCCESS = 'TEMPLATE_DELETE_SUCCESS';
export const TEMPLATE_DELETE_ERROR = 'TEMPLATES_DELETE_ERROR';
